import axios from 'axios'
import buildMockRoutes from '../mock-http'

const sessid = localStorage.getItem('sessid')

const validSessid = sessid || ''

const validIsLocalOrDev =
  window.location.href.includes('dev') || window.location.href.includes('local')

const envURL = process.env.VUE_APP_SPA_HOST

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

/*eslint-disable */
axios.defaults.headers.common['sessid'] = validSessid // for all requests
validIsLocalOrDev && (axios.defaults.headers.common['env'] = envURL)// for all requests

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const is401 = error.response.status === 401
    if (is401) {
      const { response: { headers: { redirecturl, sessid } } } = error

      localStorage.removeItem('code');

      if (sessid) localStorage.setItem('sessid', sessid)
      if (redirecturl) window.location = redirecturl
    }

    return Promise.reject(error)
  }
);

if (process.env.NODE_ENV === 'local') buildMockRoutes(axios)

export default axios
